import { defineMigrations } from "@supersig/store";
/** @public */ export const gptProps = {};
/** @internal */ export const gptLocalizationTranslationProviderMigrations = defineMigrations({});
export const GPTLocalizationTranslationProviderInfo = {
    migrations: gptLocalizationTranslationProviderMigrations,
    props: gptProps
};
